const account = {
  account: {
    plan: {
      title: "Current Plan",
      button: {
        change: "Change Plan",
      },
      fee_type: {
        number: "Number of Data",
        capacity: "Data Capacity",
      },
      plan_type: {
        standard: {
          index: "xCausal™ Standard (Standard Edition)",
          func_1: "BI dashboards",
          func_2:
            "Causal Discovery (3 algorithms available) * Plans to add more",
          func_3: "Causal Inference (Structural Causal Model base)",
          func_4: "Smallytics Algorithm",
          func_5: "Mixed use of discrete and continuous values",
          func_6: "Natural Direct Effect (NDE) Natural Indirect Effect (NIE)",
          func_7: "Robustness Test",
        },
        healthcare: {
          index: "xCausal™ for Healthcare (Healthcare Edition)",
          func_1: "BI dashboards",
          func_2:
            "Causal Discovery (3 algorithms available) * Plans to add more",
          func_3: "Causal Inference (Structural Causal Model base)",
          func_4: "Smallytics Algorithm",
          func_5: "Mixed use of discrete and continuous values",
          func_6: "Natural Direct Effect (NDE) Natural Indirect Effect (NIE)",
          func_7: "Robustness Test",
          func_8: "Health Care Dashboard",
          func_9: "Scientific Paper Search function",
          func_10:
            "CKE-LLM (Causal Knowledge Extraction LLM / MSD manual available)",
          func_11: "Use of you'd™ application and data linkage",
        },
      },
    },
    price: {
      title: "",
    },
    payment: {
      title: "Payment Method",
      button: {
        add: "Add Card",
        change: "Change Card",
      },
    },
    danger_zone: {
      title: "Danger Zone",
      section: {
        title: "Cancel subscription",
        desc: "Once deleted, it will be gone forever. Please be certain.",
        button: {
          cancel: "Cancel request",
        },
      },
    },
  },

  // ACCOUNT
  "account-title": "Account",
  "account-discription":
    "On this page, you can manage contracts, members, etc. related to your organization.",

  // PROFILE
  "account-profile-tab": "Profile",

  "account-profile-project-title": "Project",
  "account-profile-project-field-0": "Project name",

  "account-profile-title": "Profile",
  "account-profile-field-0": "Project name",
  "account-profile-field-1": "Organization name",
  "account-profile-field-2": "Email",
  "account-profile-field-3": "Phone Number",

  "account-profile-owner-title": "Owner",
  "account-profile-owner-field-1": "Department",
  "account-profile-owner-field-2": "Position",
  "account-profile-owner-field-3": "Name",

  "account-profile-address-title": "Address",
  "account-profile-address-field-1": "Address",
  "account-profile-address-field-2": "City",
  "account-profile-address-field-3": "Prefecture",
  "account-profile-address-field-4": "Postcode",
  "account-profile-address-field-5": "Country",

  "account-profile-logo-title": "Profile logo",
  "account-profile-logo-note":
    "Note: Uploaded Profile logos will be managed and used in accordance with the Terms of Use.",

  "account-profile-field-error-0": "This field is required.",
  "account-profile-field-error-1": "This field is required.",
  "account-profile-field-error-2": "Please enter a valid email address.",
  "account-profile-field-error-3": "Please enter a valid phone number.",
  "account-profile-field-error-4": "Please enter a valid postcode.",
  "account-profile-field-error-5": "Please enter a valid country code.",
  "account-profile-field-error-6": "Please enter a valid url.",
  "account-profile-field-error-7":
    "Please upload valid logo data (PNG, JPEG, WebP).",
  "account-profile-field-error-8": "Uploads must not exceed 1MB.",

  "account-profile-submit-1": "Update profile",
  "account-profile-submit-2": "Upload new picture",

  "account-profile-toast-success": "Updated successfully.",
  "account-profile-toast-error": "Update failed.",

  // MEMBER
  "account-member-tab": "Member",
  "account-member-title": "Member",
  "account-member-desc":
    "This page allows you to manage and edit member information.",

  "account-member-request-msg": "has requested a change to the Expert role.",
  "account-member-request-button-accept": "Accept",
  "account-member-request-button-reject": "Reject",

  "account-member-account-num1": "Accounts:",
  "account-member-account-num2": "used",
  "account-member-support-num": "Support:",
  "account-member-user-num": "User:",
  "account-member-count-admin": "Admin",
  "account-member-count-expert": "Expert",
  "account-member-count-user": "User",
  "account-member-count-support": "Support",

  "account-member-toolbar": "Add Member",

  "account-member-table-col1": "Name",
  "account-member-table-col2": "Email",
  "account-member-table-col3": "Role",
  "account-member-table-col4": "Login at",
  "account-member-table-col5": "Updated at",

  "account-member-modal-add-title": "Add Member",
  "account-member-modal-add-discription": "Click update when you are done.",
  "account-member-modal-add-field-error-1": "This field is required.",
  "account-member-modal-add-field-error-2":
    "Please enter a valid email address.",
  "account-member-modal-add-field-error-3":
    "Please enter a valid password. (At least 8 characters, including upper and lower case letters, numbers, and special characters).",
  "account-member-modal-add-filed-1": "Name",
  "account-member-modal-add-filed-2": "Email",
  "account-member-modal-add-filed-3": "Password",
  "account-member-modal-add-filed-4": "Roles",
  "account-member-modal-add-filed-4-option-1": "Expert",
  "account-member-modal-add-filed-4-option-2": "Admin",
  "account-member-modal-add-filed-4-option-3": "Partner",
  "account-member-modal-add-filed-4-option-4": "User",
  "account-member-modal-add-submit": "Add member",
  "account-member-modal-add-toast-success": "Updated successfully.",
  "account-member-modal-add-toast-error": "Update failed.",

  "account-member-modal-edit-title": "Edit Member",
  "account-member-modal-edit-discription": "Click update when you are done.",
  "account-member-modal-edit-field-error-1": "This field is required.",
  "account-member-modal-edit-filed-1": "Name",
  "account-member-modal-edit-filed-2": "Roles",
  "account-member-modal-edit-filed-2-option-1": "Expert",
  "account-member-modal-edit-filed-2-option-2": "Admin",
  "account-member-modal-edit-filed-2-option-3": "Partner",
  "account-member-modal-edit-filed-2-option-4": "User",
  "account-member-modal-edit-submit": "Save",
  "account-member-modal-edit-toast-success": "Updated successfully.",
  "account-member-modal-edit-toast-error": "Update failed.",

  "account-member-modal-self-edit-title": "Edit Member",
  "account-member-modal-self-edit-discription":
    "Click update when you are done.",
  "account-member-modal-self-edit-field-error-1": "This field is required.",
  "account-member-modal-self-edit-field-error-2":
    "Please enter a valid password. (At least 8 characters, including upper and lower case letters, numbers, and special characters).",
  "account-member-modal-self-edit-filed-1": "Name",
  "account-member-modal-self-edit-filed-2": "Old Password",
  "account-member-modal-self-edit-filed-3": "New Password",
  "account-member-modal-self-edit-submit": "Save",
  "account-member-modal-self-edit-toast-success": "Updated successfully.",
  "account-member-modal-self-edit-toast-error": "Update failed.",

  "account-member-modal-delete-title": "Delete Member",
  "account-member-modal-delete-discription": "Click update when you are done.",
  "account-member-modal-delete-field-error-1": "This field is required.",
  "account-member-modal-delete-field-error-2":
    "Please enter a valid email address.",
  "account-member-modal-delete-filed-1": "Name",
  "account-member-modal-delete-filed-2": "Email",
  "account-member-modal-delete-submit": "Delete",
  "account-member-modal-delete-toast-success": "Updated successfully.",
  "account-member-modal-delete-toast-error": "Update failed.",

  "account-member-dialog-reset-title": "MFA Reset",
  "account-member-dialog-reset-desc":
    "Please confirm that the member information is correct.",

  "account-member-dialog-reset-field1": "Name",
  "account-member-dialog-reset-field1-validate": "This field is required.",
  "account-member-dialog-reset-field2": "Email",
  "account-member-dialog-reset-field2-validate":
    "Please enter an email address.",

  "account-member-dialog-reset-api-loading": "Processing MFA reset...",
  "account-member-dialog-reset-api-success":
    "MFA reset was successfully completed.",
  "account-member-dialog-reset-api-error": "MFA reset failed.",

  "account-member-dialog-reset-button": "Reset",

  "account-member-modal-role-title": "Roles for the xCausal™",

  "account-member-modal-role-name-1": "Expert",
  "account-member-modal-role-name-2": "Admin",
  "account-member-modal-role-name-3": "Partner",
  "account-member-modal-role-name-4": "User",

  "account-member-modal-role-item-1": "Using the Assistant - User Mode",
  "account-member-modal-role-item-2": "Using the Assistant - Expert Mode",
  "account-member-modal-role-item-3": "Using the Dashboard",
  "account-member-modal-role-item-4": "Using the Causal Graph",
  "account-member-modal-role-item-5": "Using the Data Mgmt.",
  "account-member-modal-role-item-6": "Using the RCA",
  "account-member-modal-role-item-7": "Using the CATE",
  "account-member-modal-role-item-8": "Using the Account",
  "account-member-modal-role-item-9": "Edit Profile",
  "account-member-modal-role-item-10": "Upload Profile Logo",
  "account-member-modal-role-item-11": "Add Member",
  "account-member-modal-role-item-12": "Delete Member",
  "account-member-modal-role-item-13": "Edit Plan",
  "account-member-modal-role-item-14": "View Invoice",
  
  // BILLING
  "account-billing-tab": "Billing & Plan",
  "account-billing-section-1-title": "Current Plan",
  "account-billing-section-1-discription":
    "This page allows you to manage contracts, members, etc. related to your organization.",
  "account-billing-section-2-title": "Edit Plan",
  "account-billing-section-2-discription":
    "This page allows you to manage contracts, members, etc. related to your organization.",

  // INVOICE
  "account-invoice-tab": "Invoice",
  "account-invoice-title": "Invoice",
  "account-invoice-desc":
    "This page allows you to manage payment information and invoice, etc. related to your organization.",

  "account-invoice-table-col1": "Invoice ID",
  "account-invoice-table-col2": "Datetime",
  "account-invoice-table-col3": "Price",
  "account-invoice-table-col4": "Download",

  // SUPPORT
  "account-support-tab": "Support",
  "account-support-title": "Support",
};

export default account;
